import * as React from 'react';
import classNames from 'classnames';
import * as _ from 'lodash';
import { withRouter } from 'react-router';
import Tooltip from '../../../components/Tooltip';
import { __, setTableParams } from '../../../core/utils';
import {
  removeTaskFromGroup,
  removeTaskFromSubstage,
} from '../../../redux/actions/table/all_tasks';
import CloseMiddleIcon from '../../../assets/images/close-middle-15x15.svg';
import styles from '../../../styles/flyouts/tasks/Relations.scss';
import { confirmRelationRemoval, openRelationTask } from './relationHelpers';

const TaskPath = ({ data, match }) => {
  const pathItems = data.path || [];

  const substageLabel = (item) => {
    const label = item.label || '';
    const parts = label.match(/^([^:]+):\s*(.*)$/);

    return {
      code: item.code || _.get(parts, 1) || '',
      title: _.get(parts, 2) || label,
    };
  };

  const pathTaskLabel = (item) => (
    <span className={styles.pathTaskText}>
      {item.identifier && (
        <span className={styles.pathTaskIdentifier}>T-{item.identifier}</span>
      )}
      <Tooltip text={item.label}>
        <span className={styles.pathTaskTitle}>{item.label}</span>
      </Tooltip>
    </span>
  );

  const removePath = (event) => {
    event.stopPropagation();

    const pathType = _.get(_.last(pathItems), 'type');

    confirmRelationRemoval({
      description: __(
        'tasks.all-tasks.flyout.relations.are-you-sure-remove-path',
      ),
      notification: __('tasks.all-tasks.flyout.relations.path-removed'),
      remove: () =>
        pathType === 'group'
          ? removeTaskFromGroup(data.id)
          : removeTaskFromSubstage(data.id),
      taskId: data.id,
      match,
    });
  };

  return (
    <>
      <div className={classNames(styles.flex, styles.sectionHeader)}>
        <div className={styles.f1}>
          <label className={styles.label}>
            {__('tasks.all-tasks.flyout.relations.path')}
          </label>
          <div className={styles.pathDescription}>
            {__('tasks.all-tasks.flyout.relations.path-description')}
          </div>
        </div>
        <div className={styles.headerActions}>
          <button
            onClick={() =>
              setTableParams('all_tasks', {
                add_parent_task_wizard: data.id,
              })
            }
          >
            {__('button.change-path')}
          </button>
        </div>
      </div>

      {!_.isEmpty(pathItems) && (
        <div className={styles.pathRow}>
          <div className={styles.pathItems}>
            {_.map(pathItems, (item, index) => (
              <React.Fragment key={`${item.type}-${item.id}-${index}`}>
                {item.type === 'substage' ? (
                  <div className={styles.pathItem}>
                    <span className={styles.pathType}>
                      {__('tasks.all-tasks.flyout.relations.substage')}
                    </span>
                    {substageLabel(item).code && (
                      <span className={styles.pathSubstageCode}>
                        {substageLabel(item).code}
                      </span>
                    )}
                    <Tooltip text={item.label}>
                      <span className={styles.pathName}>
                        {substageLabel(item).title}
                      </span>
                    </Tooltip>
                  </div>
                ) : (
                  <div className={styles.pathTaskWrapper}>
                    <span className={styles.pathType}>
                      {__('tasks.all-tasks.flyout.relations.group-task')}
                    </span>
                    <div className={styles.pathTask}>
                      <div
                        onClick={() => openRelationTask(item, match)}
                        className={classNames(
                          styles.pathTaskLink,
                          item.can_view && item.id
                            ? styles.clickable
                            : styles.disabled,
                        )}
                      >
                        {item.can_view ? (
                          pathTaskLabel(item)
                        ) : (
                          <Tooltip
                            text={__(
                              'tasks.all-tasks.flyout.parent-tasks.tooltip.private-parent-task.no-access',
                            )}
                          >
                            {pathTaskLabel(item)}
                          </Tooltip>
                        )}
                      </div>
                    </div>
                  </div>
                )}
                {index < pathItems.length - 1 && (
                  <span className={styles.pathSeparator}>›</span>
                )}
              </React.Fragment>
            ))}
          </div>
          <div className={styles.pathActions}>
            <Tooltip text={__('tasks.all-tasks.flyout.relations.remove-path')}>
              <CloseMiddleIcon onClick={removePath} />
            </Tooltip>
          </div>
        </div>
      )}
    </>
  );
};

export default withRouter(TaskPath);
